import {Navigate, Outlet} from 'react-router-dom';
import {useBuyerSupport} from '../app/hooks';

const AdminBuyerChatProtectedRoutes = () => {
  const token = useBuyerSupport().supportBuyerToken;
  return token ? <Outlet /> : <Navigate to='/support-desk' replace />;
};
// const AdminProtectedRoutes = () => {
//   return <Outlet />;
// };

export default AdminBuyerChatProtectedRoutes;
